"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setByDotKey = void 0;
/** 2024 02 added _ to support some names in SSM parameters, NOTE adding - needs testing as simply - or \- breaks construction */
const attributeNameRegex = /[a-zA-Z0-9_-]+/g;
const arrayPartRegex = /\[\d+\]/g;
const objectAttributeRegex = /\.\S+/g;
const attributeSeparatorRegex = /(\S(?=(\.|\[)))|(\.\S)/g;
const debug = false;
const keyToType = (k) => {
    let res = undefined;
    if (typeof k === 'number') {
        res = new Array();
    }
    else if (typeof k === 'string') {
        res = {};
    }
    else
        res = undefined;
    debug && console.log(`KeyToType got ${k} ${typeof k} returning `, res);
    return res;
};
const setByDotKey = (key, value, object) => {
    /** dot support, excluding baseAttribute */
    debug && console.log(' key', key);
    const pattern = attributeNameRegex;
    const keyArray = key.match(pattern) || [];
    keyArray.reduce((mutable, c, i, a) => {
        const thisKey = c;
        const nextKey = a[i + 1];
        const thisKeyType = isNaN(parseInt(thisKey)) ? 'string' : 'number';
        const nextKeyType = isNaN(parseInt(nextKey)) ? nextKey : parseInt(nextKey);
        const thisObjectType = thisKeyType === 'string' ? 'object' : 'array';
        try {
            switch (thisObjectType) {
                case 'array':
                    {
                        if (!(mutable instanceof Array)) {
                            console.log({ thisKey, thisObjectType });
                            throw new Error('Not array');
                        }
                        if (!mutable[parseInt(thisKey)]) {
                            const nextNew = keyToType(nextKeyType) ?? value;
                            mutable[parseInt(thisKey)] = nextNew ?? null;
                        }
                        else if (!nextKey) {
                            mutable[parseInt(thisKey)] = value;
                        }
                    }
                    break;
                case 'object':
                    {
                        if (mutable instanceof Array) {
                            console.log({ thisKey, thisObjectType });
                            throw new Error('Not object');
                        }
                        if (!mutable[thisKey.toString()]) {
                            const nextNew = keyToType(nextKeyType) ?? value;
                            mutable[thisKey.toString()] = nextNew;
                        }
                        else if (!nextKey) {
                            mutable[thisKey.toString()] = value;
                        }
                    }
                    break;
            }
        }
        catch (e) {
            console.log(`Err ${e.message} on `, { thisKey, nextKey, value });
            throw e;
        }
        return mutable[thisKey.toString()];
    }, object);
    return object;
};
exports.setByDotKey = setByDotKey;
